export default "__VITE_ASSET__DvOn3V37__"